var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("login-layout", [
    _c("div", { staticClass: "text-center" }, [
      _vm.processing
        ? _c("div", [
            _c("h3", [_vm._v("Your response is being recorded")]),
            _vm._v(" "),
            _c("p", [_vm._v("Please wait...")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.processing && _vm.success
        ? _c("div", [
            _c("h3", [_vm._v("Thank You!")]),
            _vm._v(" "),
            _c("p", [_vm._v("Successfully recorded your response")]),
            _vm._v(" "),
            _c("div", { staticClass: "flex w-full justify-center" }, [
              _c("a", { staticClass: "btn btn-dark", attrs: { href: "/" } }, [
                _vm._v("\n          Continue to Dashboard\n        "),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.processing && !_vm.success
        ? _c("div", [
            _c("h3", [_vm._v("Unable To Record Response")]),
            _vm._v(" "),
            _c("p", [_vm._v("\n        " + _vm._s(this.message) + "\n      ")]),
            _vm._v(" "),
            _c("div", { staticClass: "flex w-full justify-center" }, [
              _c("a", { staticClass: "btn btn-dark", attrs: { href: "/" } }, [
                _vm._v("\n          Continue to Dashboard\n        "),
              ]),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }